export default {

	threshold: 0.1,
	activeClassName: 'is-visible',

	init() {
		const self = this;
		const options = {
			root: null,
			threshold: [this.threshold]
		};

		const observer = new IntersectionObserver(function(entries){
			entries.forEach(entry => {
				if(entry.intersectionRatio >= self.threshold && !entry.target.classList.contains(self.activeClassName)) {
					entry.target.classList.add(self.activeClassName);
				}
			});
		}, options);

		Array.from(document.querySelectorAll('.transition')).forEach((elm) => {
			observer.observe(elm);
		});
	}

}



// WEBPACK FOOTER //
// ./src/js/transition.js